export const breakpoints = {
    small: 320,
    medium: 600,
    large: 960,
    xlarge: 1280,
    xxlarge: 1440,
};
const htmlFontSize = 16;
export const remCalc = (value) => value / htmlFontSize;
//# sourceMappingURL=index.js.map
